export type UserActionGet = {
  type: 'get' | 'user/get'
}

export type AuthActionRefresh = {
  type: 'refresh' | 'auth/refresh',
  isLoginRoute: boolean,
  successCallback: Function,
  failCallback: Function
}

export enum AppActionsType {
  updateError = 'updateError'
}

export enum PatientActionsType {
  getPatients = 'getPatients'
}

export enum DeviceActionsType {
  getDevices = 'getDevices',
  newDevice = 'newDevice',
  updateDevice = 'updateDevice',
  deleteDevice = 'deleteDevice',
  loanDevice = 'loanDevice',
  returnDevice = 'returnDevice'
}
